<template lang="pug">
.row.justify-content-center
  #free_register_form.col-11(v-if="showForm")
    loader-vue(:visible='sendingRequest')
    p.free_Register__title_Form {{ t('free_register.form_title') }}
    p(v-text="t('free_register.form_text', { brand: app_brand })")
    form
      .row.mt-3
        .col-12.col-lg-6.mb-3.mb-lg-0
          input#input_name.form-control(type='text' :placeholder='namePlaceholder' v-model='name')
        .col-12.col-lg-6
          input#input_last_name.form-control(type='text' :placeholder='lastNamePlaceholder' v-model='lastName')
      .row.mt-3
        .col-12(:class="cityClasses")
          input#input_city.form-control(type='text' :placeholder='cityPlaceholder' v-model='city')
        .col-12.col-lg-6(v-if="zipCodeEnabled")
          input#input_zip_code.form-control(
            type='zip'
            :placeholder='zipCodePlaceholder'
            v-model='zipCode'
            data-cy='zip_code_input'
          )
      .row.mt-3
        .col-12.col-lg-6.mb-3.mb-lg-0
          input#input_phone.form-control(type='tel' :placeholder='phonePlaceholder' v-model='phone')
        .col-12.col-lg-6
          input#input_email.form-control(type='email' :placeholder='emailPlaceholder' v-model='email')
      .row.mt-3
        .col-12
          forms-lopd-text-vue
      .row.mt-4.justify-content-center
        .col-5
            captcha-vue(ref='captcha')
      .row.mt-3
        .col-12
          forms-messages-list-vue(:messages='errors' :title='errorsTitle')
      .row.mt-3
        .col-12.d-flex.justify-content-center
          button#submit_free_register_form.btn.btn-primary.submit.btn-submit(@click.prevent='submitForm')
            | {{ t('free_register.send') }}
  #request_response_container.login_form_per(v-else)
    .alert.alert-success(v-if="!requestError")
      p.message-success(v-html="t('free_register.submit_message')")
    .alert.alert-danger(v-else)
      p.message-error.text-center(v-html="requestError")
    .d-flex.justify-content-center
      a#back_to_form.btn.btn-primary.submit(href='#' @click='toggleForm') {{ t('free_register.back_form') }}
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import ApiClient from 'common/ApiClient'
import constants from 'common/constants.js'
import mixins from 'common/mixins'
import Validator from 'common/Validator'

export default {
  mixins: [mixins.translate, mixins.requests],
  name: 'free-register-form-vue',
  components: {
    'forms-lopd-text-vue': () => import(/* webpackChunkName: "[request]" */ 'components/forms/LopdText'),
    'forms-messages-list-vue': () => import(/* webpackChunkName: "[request]" */ 'components/forms/MessagesList'),
    'loader-vue': () => import(/* webpackChunkName: "[request]" */ 'components/Loader'),
    'captcha-vue': () => import(/* webpackChunkName: "[request]" */ 'components/Captcha')
  },
  data() {
    return {
      name: '',
      lastName: '',
      city: '',
      zipCode: '',
      phone: '',
      email: '',
      contactSource: 'Alta Gratuita',
      sendingRequest: false,
      showForm: true,
      errors: {},
      requestError: null,
      namePlaceholder: I18n.t('free_register.placeholders.name'),
      lastNamePlaceholder: I18n.t('free_register.placeholders.last_name'),
      cityPlaceholder: I18n.t('free_register.placeholders.city'),
      zipCodePlaceholder: I18n.t('free_register.placeholders.zip_code'),
      phonePlaceholder: I18n.t('free_register.placeholders.phone'),
      emailPlaceholder: I18n.t('free_register.placeholders.email'),
      errorsTitle: I18n.t('free_register.errors_title'),
      phoneMinLength: constants.PHONE_MIN_LENGTH,
      phoneMaxLength: constants.PHONE_MAX_LENGTH,
      textMaxLength: constants.TEXTAREA_MAX_LENGTH
    }
  },
  methods: {
    submitForm() {
      if (this.validateForm()) {
        this.sendData()
      }
    },
    validateForm() {
      let validatorParams = [
        {
          fields: I18n.t('free_register.fields.name'),
          values: this.name,
          validates: 'filled',
        },
        {
          fields: I18n.t('free_register.fields.last_name'),
          values: this.lastName,
          validates: 'filled',
        },
        {
          fields: I18n.t('free_register.fields.city'),
          values: this.city,
          validates: 'filled',
        },
        {
          fields: I18n.t('free_register.fields.phone'),
          values: this.phone,
          params: [this.phoneMinLength, this.phoneMaxLength],
          validates: 'length_between',
        },
        {
          fields: I18n.t('free_register.fields.email'),
          values: this.email,
          validates: 'email_format',
        },
        {
          fields: I18n.t('free_register.fields.check_info'),
          values: this.lopd_privacy,
          validates: 'checked',
        }
      ]

      if (this.zipCodeEnabled) {
        validatorParams.push({
          fields: I18n.t('free_register.fields.zip_code'),
          values: this.zipCode,
          validates: 'filled',
        })
      }

      this.setErrors({})

      let validator = new Validator(validatorParams).do()
      if (!this.$refs.captcha.isVerified || !validator.success) {
        this.showErrorMessages(validator.messages, this.$refs.captcha.errorMessage())
        return false
      }

      return true
    },
    async sendData() {
      this.requestError = null
      this.sendingRequest = true

      let payload = {
        name: this.name,
        lastName: this.lastName,
        city: this.city,
        zipCode: this.zipCode,
        phone: this.phone,
        email: this.email,
        contactSource: this.contactSource,
        lopdPrivacy: this.lopd_privacy,
        lopdGroup: this.lopd_group,
        lopdPublicity: this.lopd_publicity
      }

      const sendRequestResponse = await this.sendFreeRegisterRequest(payload)
      if (sendRequestResponse.failed) {
        this.requestError = sendRequestResponse.data.error
        this.requestFailed()
        return
      }

      this.requestSuccess()
    },
    requestSuccess() {
      this.clearForm()
      this.hideForm()
    },
    requestFailed() {
      this.hideForm()
    },
    async sendFreeRegisterRequest(payload) {
      const api = new ApiClient()
      const response = await api.post(gon.url_for.free_register_send_request, payload)

      return response
    },
    showErrorMessages(validatorErrors, captchaError) {
      let errorMessages = {}
      if (Object.keys(validatorErrors).length > 0) {
        errorMessages = { ...errorMessages, ...validatorErrors }
      }
      if (captchaError !== '') {
        errorMessages = { ...errorMessages, 'captcha': captchaError }
      }
      this.setErrors(errorMessages)
    },
    setErrors(errors) {
      this.errors = errors
    },
    clearForm() {
      this.name = ''
      this.lastName = ''
      this.city = ''
      this.zipCode = ''
      this.phone = ''
      this.email = ''
      this.errors = {}
      this.clearLopd()
    },
    hideForm() {
      this.sendingRequest = false
      this.showForm = false
    },
    toggleForm() {
      this.showForm = !this.showForm
    },
    ...mapMutations('lopd_texts', ['clearLopd'])
  },
  computed: {
    ...mapState('lopd_texts', [
      'lopd_privacy',
      'lopd_group',
      'lopd_publicity'
    ]),
    zipCodeEnabled() {
      return gon.paisiso != 'cri'
    },
    cityClasses() {
      return this.zipCodeEnabled ? 'col-lg-6 mb-3 mb-lg-0' : ''
    }
  }
}
</script>
